import React from 'react';
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const labels = {
  cpu: 'CPU', memory: 'Memoria', network_in: 'Red entrante', network_out: 'Red saliente',
  disk_read: 'Lectura de disco', disk_write: 'Escritura de disco', disponibilidad: 'Disponibilidad',
  disk_usage: 'Uso de disco por partición',
};

function PartitionChart({ partitions }) {
  const points = new Map();
  partitions.forEach(partition => partition.points.forEach(point => {
    if (!points.has(point.timestamp)) points.set(point.timestamp, { timestamp: point.timestamp });
    points.get(point.timestamp)[partition.path] = point.value;
  }));
  const data = [...points.values()].sort((a, b) => Date.parse(a.timestamp) - Date.parse(b.timestamp));
  return <ResponsiveContainer><LineChart data={data}>
    <XAxis dataKey="timestamp" hide /><YAxis domain={[0, 100]} /><Tooltip />
    {partitions.map((partition, index) => <Line key={partition.path}
      name={partition.path} dataKey={point => point[partition.path]}
      stroke={['#a78bfa', '#22d3ee', '#34d399', '#f59e0b'][index % 4]} dot={false} />)}
  </LineChart></ResponsiveContainer>;
}

export default function CloudMetricCharts({ result }) {
  return <>
    <p className="text-xs text-violet-200">
      Consultado: {result.queried_at}
      {result.partial && ' · Consulta parcial: revisa los errores por métrica'}
    </p>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {Object.entries(result.metric_status).map(([key, status]) => <article key={key}
        className="border border-violet-500/25 bg-[#1a0d36]/70 rounded-2xl p-5">
        <h3 className="text-base font-bold text-violet-100">
          {labels[key] || key} {status.unit && `(${status.unit})`}
        </h3>
        {status.aggregation && <p className="text-xs text-white/60">
          {status.aggregation === 'sum' ? 'Suma' : 'Promedio'} entre dimensiones · intervalo {status.interval}
        </p>}
        <p className={status.status === 'error' ? 'text-red-300 text-sm' : 'text-white/60 text-sm'}>
          {status.status === 'no_data' ? 'Sin datos en el periodo; revisa el plugin Compute Instance Monitoring.'
            : status.message || status.status}
        </p>
        {result.metrics[key]?.length > 0 && <div className="h-48">
          {key === 'disk_usage' ? <PartitionChart partitions={result.metrics.disk_usage} /> :
          <ResponsiveContainer><LineChart data={result.metrics[key]}>
            <XAxis dataKey="timestamp" hide /><YAxis /><Tooltip />
            <Line dataKey="value" stroke="#a78bfa" dot={false} />
          </LineChart></ResponsiveContainer>}
        </div>}
      </article>)}
    </div>
  </>;
}
